import React from 'react';
import { Modal, Button, Form, Select } from 'antd';
import { presenceTypeOptions } from '../../../../data/options';

const { Option } = Select;

class Filter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,
        };
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    render() {

        return (
            <Modal
                title="Filter"
                width={300}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Tutup</Button>
                    <Button type='primary' onClick={this.props.setTableFilterFromTemp}>Terapkan</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    
                    <Form.Item label="Tipe Presensi">
                        <Select
                            allowClear
                            name="tipe"
                            placeholder="Tipe presensi"
                            onChange={(e, newValue) => {
                                this.props.setTempTableFilter("tipe", newValue ? newValue.value : null)
                            }}
                            value={this.props.values.tipe}
                            style={{ width: '100%' }}
                        >
                            {presenceTypeOptions.map((row, i) => <Option key={i} value={row.value}>{row.value}</Option>)}
                        </Select>
                    </Form.Item>
                </Form >
            </Modal >
        )
    }
}

export default Filter;
